// /notme — self-service device exclusion (founder's PC/phone/laptop; any
// teammate too). Visiting it once EXCLUDES the device immediately — no button
// press needed, because the whole point is "open this link on your phone,
// done" — and shows an unmissable status so a device can be re-checked
// anytime. Undo lives right there. Deliberately unlisted (no nav/footer/
// sitemap links); it's an internal tool with a shareable URL, not a feature.
import { useEffect, useState } from 'react';
import { PageShell } from './shell';
import { isExcluded, setExcluded } from '../track';

export function NotMePage() {
  // exclude on arrival, then render the resulting truth
  const [excluded, setExcludedState] = useState(false);
  useEffect(() => {
    setExcluded(true);
    setExcludedState(isExcluded()); // read back — storage may be blocked
  }, []);

  const toggle = () => {
    setExcluded(!excluded);
    setExcludedState(isExcluded());
  };

  return (
    <PageShell
      kicker="Internal · Analytics"
      title={excluded ? 'This device is off the radar.' : 'This device is being counted.'}
      sub={excluded
        ? 'Visits from this browser no longer count toward ClipRadar’s stats — pages, downloads, purchases, none of it.'
        : 'Exclusion didn’t stick (storage may be blocked) — or you just turned it back on.'}
    >
      <div style={{
        display: 'flex', alignItems: 'center', gap: 14, padding: '18px 20px', borderRadius: 14,
        border: '1px solid var(--line-2)', background: 'var(--surface-card)', maxWidth: 480,
      }}>
        <span aria-hidden="true" style={{
          width: 10, height: 10, borderRadius: '50%', flex: 'none',
          alignSelf: 'flex-start', marginTop: 7, // bullet the status LINE, not the block gap
          background: excluded ? 'var(--signal-400)' : 'var(--warning)',
          boxShadow: excluded ? '0 0 10px var(--signal-glow)' : 'none',
        }}></span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <b style={{ display: 'block', fontSize: 14.5, color: 'var(--fg-1)' }}>
            {excluded ? 'Excluded from analytics' : 'Not excluded'}
          </b>
          <span style={{ fontSize: 12.5, color: 'var(--fg-3)' }}>
            {excluded ? 'Flag set in cookie + local storage on this browser.' : 'Reload to try again, or use the button.'}
          </span>
        </div>
        {/* quiet outline undo — the STATUS is the page's message, not this button */}
        <button onClick={toggle} className="crw-linkbtn" style={{
          padding: '8px 16px', borderRadius: 999, border: '1px solid var(--line-2)',
          fontFamily: 'var(--font-mono)', fontSize: 12.5, color: 'var(--fg-1)', whiteSpace: 'nowrap',
        }}>
          {excluded ? 'Count me again' : 'Exclude this device'}
        </button>
      </div>
      <p style={{ margin: '18px 0 0', fontSize: 13, lineHeight: 1.65, color: 'var(--fg-3)', maxWidth: 480 }}>
        Open this page once on every device you don’t want polluting the numbers — it remembers
        per browser. If you clear cookies and site data, revisit it.
      </p>
    </PageShell>
  );
}
